<template>
  <div v-loading="true" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  name: "SSOProcessing",

  data() {
    return {
      loading: true,
    };
  },

  mounted() {
    // voxo-api's OAUTH_REDIRECT_URI points here; /login owns the post-login setup
    this.$router.replace({ path: "/login", query: this.$route.query });
  },
};
</script>
